module.exports = __webpack_public_path__ + "static/media/AE.d038b7ed.svg";